<template>
	<core-layout-content medium>
		<!-- Headline -->
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("update_insurance_type") }}</template>
		</core-layout-headline-and-actions>

		<!-- Body -->
		<j-card class="xs-12 bg5 r2 pt4 pb4 mb4">
			<!-- Type ID -->
			<div class="flex wrap xs-12 mb8 pl4 pr4 xs-middle">
				<label class="lh125 fw7">{{ $t("type_id") }}</label>
				<span class="ml2 fs3 c2">{{ `(${$t("read_only")})` }}</span>
				<j-base-input-text
					class="xs-12 mt2"
					:value="this.id"
					:isReadOnly="true"
				></j-base-input-text>
			</div>

			<!-- English Label -->
			<div class="xs-12 mb2 pl4 pr4 c6">{{ $t("english") }}</div>

			<!-- English Name -->
			<div class="xs-12 mb4 pl4 pr4">
				<label class="xs-12 lh125 fw7">{{ $t("name") }}</label>
				<j-base-input-text
					class="mt2"
					v-model="form.englishName"
				></j-base-input-text>
			</div>

			<!-- English Description -->
			<div class="xs-12 mb10 pl4 pr4">
				<label class="xs-12 lh125 fw7">{{ $t("description") }}</label>
				<j-base-input-text
					class="mt2"
					v-model="form.englishDescription"
				></j-base-input-text>
			</div>

			<!-- Traditional Chinese Label -->
			<div class="xs-12 mb2 pl4 pr4 c6">{{ $t("traditional_chinese") }}</div>

			<!-- Traditional Chinese Name -->
			<div class="xs-12 mb4 pl4 pr4">
				<label class="xs-12 lh125 fw7">{{ $t("name") }}</label>
				<j-base-input-text
					class="mt2"
					v-model="form.traditionalName"
				></j-base-input-text>
			</div>

			<!-- Traditional Chinese Description -->
			<div class="xs-12 mb10 pl4 pr4">
				<label class="xs-12 lh125 fw7">{{ $t("description") }}</label>
				<j-base-input-text
					class="mt2"
					v-model="form.traditionalDescription"
				></j-base-input-text>
			</div>

			<!-- Simplified Chinese Label -->
			<div class="xs-12 mb2 pl4 pr4 c6">{{ $t("simplified_chinese") }}</div>

			<!-- Simplified Chinese Name -->
			<div class="xs-12 mb4 pl4 pr4">
				<label class="xs-12 lh125 fw7">{{ $t("name") }}</label>
				<j-base-input-text
					class="mt2"
					v-model="form.simplifiedName"
				></j-base-input-text>
			</div>

			<!-- Simplified Chinese Description -->
			<div class="xs-12 mb10 pl4 pr4">
				<label class="xs-12 lh125 fw7">{{ $t("description") }}</label>
				<j-base-input-text
					class="mt2"
					v-model="form.simplifiedDescription"
				></j-base-input-text>
			</div>

			<div class="pl4 pr4">
				<!-- Back Button -->
				<j-button type="secondary" class="mr2" @click="goBack()">{{
					$t("back")
				}}</j-button>
				<!-- Submit Button -->
				<j-button @click="handleSubmit">
					{{ $t("update_insurance_type") }}
				</j-button>
			</div>
		</j-card>
	</core-layout-content>
</template>

<script>
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import JCard from "@/components/JCard"
import JBaseInputText from "@/components/JBaseInputText/"
import JButton from "@/components/JButton/"
import api from "../api/"

export default {
	components: {
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		JCard,
		JBaseInputText,
		JButton
	},

	props: {
		id: {
			type: String
		}
	},

	data() {
		return {
			isLoading: false,
			form: {
				typeId: this.id,
				englishName: null,
				englishDescription: null,
				traditionalName: null,
				traditionalDescription: null,
				simplifiedName: null,
				simplifiedDescription: null
			}
		}
	},

	methods: {
		goBack() {
			this.$router.back()
		},

		async initialPayload() {
			const res = await api.readAllInsuranceTypes({
				where: {
					typeId: this.id
				}
			})
			this.form.englishName = res.data.productTypes[0].name
			this.form.englishDescription = res.data.productTypes[0].description
		},

		async localizeInsuranceType(locale, value, type) {
			// localize Insurance Type Name
			// key: products-types-{typeId}-name OR products-types-{typeId}-description
			const res = await api.localizeInsuranceType({
				l10n: {
					key: `products-types-${this.form.typeId}-${type}`,
					locale: locale,
					value: value
				}
			})
		},

		async handleSubmit() {
			await Promise.all([
				this.localizeInsuranceType("en-US", this.form.englishName, "name"), // name for english locale
				this.localizeInsuranceType("zh-HK", this.form.traditionalName, "name"), // name for traditional locale
				this.localizeInsuranceType("zh-CN", this.form.simplifiedName, "name"), // name for simplified locale
				this.localizeInsuranceType(
					"en-US",
					this.form.englishDescription,
					"description"
				), // description for english locale
				this.localizeInsuranceType(
					"zh-HK",
					this.form.traditionalDescription,
					"description"
				), // description for traditional locale
				this.localizeInsuranceType(
					"zh-CN",
					this.form.simplifiedDescription,
					"description"
				) // description for simplified locale
			])

			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("insurance_type_updated")
				}
			})

			// Close modal and go back to list
			this.$router.push({ name: "InsuranceTypesList" })
		}
	},

	mounted() {
		this.initialPayload()
	}
}
</script>
